export default "__VITE_ASSET__88d386af__"